class FilterOverlay {
  constructor({
    openBtnId = 'js-filter-btn',
    overlayId = 'js-filter-overlay',
    closeBtnId = 'js-filter-close-btn',
    backdropId = 'js-filter-overlay-backdrop',
    filterCategory = 'js-filter-category',
    filterApplyBtn = 'js-filter-apply-btn',
    filterUrl = 'js-filter-url',
    selectYearId = 'js-year-select-sp',
  } = {}) {
    this.openBtn = document.getElementById(openBtnId);
    this.overlay = document.getElementById(overlayId);
    this.closeBtn = document.getElementById(closeBtnId);
    this.backdrop = document.getElementById(backdropId);
    this.categoryElements = document.querySelectorAll(`.${filterCategory}`);
    this.filterApplyBtn = document.getElementById(filterApplyBtn);
    this.filterUrl = document.getElementById(filterUrl);
    this.selectYear = document.getElementById(selectYearId);
    if (!this.openBtn || !this.overlay) return;
    this._bindEvents();
  }

  open() {
    if (this._closeOnEnd) {
      const card = this.overlay.querySelector('.c-filter__overlay--card');
      card.removeEventListener('animationend', this._closeOnEnd);
      this._closeOnEnd = null;
    }
    this.overlay.classList.remove('is-closing');
    this.overlay.hidden = false;
    this.openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.overlay.focus();
  }

  _finishClose() {
    this.overlay.classList.remove('is-closing');
    this.overlay.hidden = true;
    this.openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    this.openBtn.focus();
  }

  close() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this._finishClose();
      return;
    }
    this.overlay.classList.add('is-closing');
    const card = this.overlay.querySelector('.c-filter__overlay--card');
    if (this._closeOnEnd) {
      card.removeEventListener('animationend', this._closeOnEnd);
    }
    this._closeOnEnd = e => {
      if (e.target !== card) return;
      card.removeEventListener('animationend', this._closeOnEnd);
      this._closeOnEnd = null;
      if (this.overlay.classList.contains('is-closing')) this._finishClose();
    };
    card.addEventListener('animationend', this._closeOnEnd);
  }

  _buildFilterUrl(baseCategoryUrl, year) {
    return year !== '' ? `${baseCategoryUrl}year/${year}/` : baseCategoryUrl;
  }

  filterCategory(event) {
    const clickedElement = event.target;
    const baseCategoryUrl = clickedElement.getAttribute('data-url');
    this.categoryElements.forEach(el => el.classList.remove('active'));
    clickedElement.classList.add('active');
    this.filterUrl.value = this._buildFilterUrl(
      baseCategoryUrl,
      this.selectYear.value
    );
  }

  filterYear(event) {
    const year = event.target.value;
    const categoryArray = Array.from(this.categoryElements);
    let activeCategory = categoryArray.find(el =>
      el.classList.contains('active')
    );
    // If no active, fallback to first item
    if (!activeCategory && categoryArray.length > 0) {
      activeCategory = categoryArray[0];
    }
    if (!activeCategory) {
      // No categories at all, bail out
      this.filterUrl.value = '';
      return;
    }
    const baseCategoryUrl = activeCategory.getAttribute('data-url');
    this.filterUrl.value = this._buildFilterUrl(baseCategoryUrl, year);
  }

  applyFilter() {
    if (!this.filterUrl.value) return;
    window.location.href = this.filterUrl.value;
  }

  _bindEvents() {
    this.openBtn.addEventListener('click', () => this.open());
    this.filterApplyBtn.addEventListener('click', () => this.applyFilter());
    this.selectYear.addEventListener('change', e => this.filterYear(e));
    this.categoryElements.forEach(el => {
      el.addEventListener('click', e => {
        this.filterCategory(e);
      });
    });
    this.closeBtn &&
      this.closeBtn.addEventListener('click', () => this.close());
    this.backdrop &&
      this.backdrop.addEventListener('click', () => this.close());
    this.overlay.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new FilterOverlay();
});
